import React from 'react';
import { ImageHeader } from '../components/ImageHeader';
import presentsImage from 'url:../assets/presents-1.jpg';
import genderedIntelligenceLogo from 'url:../assets/gendered-intelligence.png';
import shoutLogo from 'url:../assets/shout.jpg';
import bafLogo from 'url:../assets/brain-aneurysm-foundation.png';
import celiaHammondLogo from 'url:../assets/celia-hammond.png';

const Gifts: React.FC = () => {
  const imageUrl = presentsImage;
  const headerContent = (<h1>Gifts</h1>);

  const charities = [
    {
      name: 'Gendered Intelligence',
      description: 'Supporting trans, non-binary and gender diverse people',
      url: 'https://genderedintelligence.co.uk/',
      logo: genderedIntelligenceLogo,
    },
    {
      name: 'Shout',
      description: 'Free 24/7 mental health text support service',
      url: 'https://giveusashout.org',
      logo: shoutLogo,
    },
    {
      name: 'Brain Aneurysm Foundation',
      description: 'Funding research and early detection to save lives',
      url: 'https://www.bafound.org/',
      logo: bafLogo,
    },
    {
      name: 'Celia Hammond Animal Trust',
      description: 'Rescuing and rehoming cats and providing low-cost veterinary care',
      url: 'https://www.celiahammond.org/',
      logo: celiaHammondLogo,
    },
  ];

  return (
    <>
      <ImageHeader headerContent={headerContent} imageUrl={imageUrl} />
      <main>
        <article className="block-content block-content-longtext">
          <p>Our cupboards are full, our shelves are tilting under the weight of Erin’s books, and our hearts are content.</p>
          <p>If you'd like to give something, we'd be honoured if you donated to one of our chosen causes instead.</p>
          <p>Feel free to ask us about them, and thank you for any support you give.</p>
          <ul className='charity-list'>
            {charities.map((charity) => (
              <li key={charity.name}>
                <a href={charity.url} target="_blank" rel="noopener noreferrer" className="charity-link">
                  <div className="charity-logo">
                    <img src={charity.logo} alt={`${charity.name} logo`} />
                  </div>
                  <div className="charity-info">
                    <strong>{charity.name}</strong>
                    <span>{charity.description}</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </article>
      </main>
    </>
  );
};

export default Gifts;
